<div class="body-2 pt-12 pl-12 pb-6 pr-6 bg-primary-600 text-on-primary-600">
    <p>TASK</p>
    <div class="display-1">{{ taskPanelService.getData().taskName }}</div>
    <div class="flex items-center gap-1"><mat-icon [svgIcon]="'mat:' + status[task.status].icon"></mat-icon>{{
        status[task.status].text }}</div>
</div>

<mat-divider></mat-divider>

<div class="p-6">
    <div class="flex justify-between items-center">
        <div class="flex-1">
            <!-- <button type="button" class="btn btn-standard" (click)="openURL(taskDetail.url)">{{
                taskDetail.label
                }}</button> -->
            <!-- <button mat-stroked-button *ngIf="expression" (click)="openURL(taskDetail.url)">{{ taskDetail.label
                }}</button> -->
            <ul>
                <li *ngFor="let taskDetail of listTaskDetails">
                    <button mat-stroked-button *ngIf="taskDetail.type === 'link'" type="button" class="btn btn-standard"
                        (click)="openURL(taskDetail.url)">{{
                        taskDetail.label
                        }}</button>
                </li>
            </ul>
        </div>
        <!-- MEMBERS -->
        <div [formGroup]="form">
            @if(users.length > 0){
            <vex-user-circles
              [users]="task.resources"
              [dialogTitle]="'Task Participants'"
              (usersChange)="onUsersChange($event)"></vex-user-circles>
            <!-- <div class="users flex-1 relative flex flex-col items-end">
                <div class="body-2 text-secondary">Who's Involved:</div>
                <div class="flex items-center">
                    <img *ngFor="let user of form.controls.users.value" [matTooltip]="user.people.nameComposed"
                        [src]="user.people.photo" class="avatar flex-none" />
                    <div (click)="userSelect.open()"
                        class="avatar text-secondary bg-app-bar cursor-pointer flex-none flex items-center justify-center">
                        <mat-icon svgIcon="mat:add"></mat-icon>
                    </div>
                </div>
                <mat-select #userSelect="matSelect" class="invisible absolute text-sm" formControlName="users"
                    multiple>
                    <mat-option *ngFor="let user of users" [value]="user">
                        <img [src]="user.people.photo"
                            class="avatar h-6 w-6 align-middle inline-block ltr:mr-2 rtl:ml-2" />
                        <span>{{ user.people.nameComposed }}</span>
                    </mat-option>
                </mat-select>
            </div> -->
            }
        </div>
        <!-- User -->
        <!-- <div class="task-header" *ngIf="detailsResources.length > 0">
            <div class="assignee-info" *ngFor="let resource of detailsResources">
                <a data-bs-toggle="modal" data-bs-target="#assignee">
                    <div class="avatar">
                        <img alt="" src="assets/img/profiles/avatar-2.jpg">
                    </div>
                    <div class="assigned-info">
                        <div class="task-head-title" *ngIf="resource.resource">Assigned To
                        </div>
                        <div class="task-head-title" *ngIf="resource.owner">Owner</div>
                        <div class="task-assignee">{{ resource.people.dataName }}</div>
                    </div>
                </a>
            </div>
        </div> -->
        <!-- End User -->
    </div>
    <!-- END MEMBERS -->

    <!-- ACCORDION -->
    <div class="section">
        <p-accordion [value]="['0']" [multiple]="true">

            <!-- @if(securityService.securityObject.isAdmin && securityService.securityObject.orgId === 148){ -->
            <p-accordion-panel value="0" *ngIf="listTaskDetails.length > 0">
                <p-accordion-header>Task Details</p-accordion-header>
                <p-accordion-content>
                <ul class="attach-list">
                    <li *ngFor="let taskDetail of listTaskDetails">
                        <ng-container
                            *ngIf="taskDetail.type === 'link'; then linkTemplate else elseTemplate"></ng-container>

                        <ng-template #linkTemplate>
                            <!-- <button type="button" class="btn btn-standard" (click)="openURL(taskDetail.url)">{{
                                taskDetail.label
                                }}</button> -->
                            <!-- <a [href]="taskDetail.url" target="_blank">{{ taskDetail.label }}</a> -->
                        </ng-template>

                        <ng-template #elseTemplate>
                            <ng-container
                                *ngIf="taskDetail.type === 'list'; then listTemplate else textTemplate"></ng-container>
                        </ng-template>

                        <ng-template #textTemplate>
                            @if(isObject(taskDetail.value)){
                            <!-- <vex-json-viewer [data]="taskDetail.value" [key]="taskDetail.key"/> -->
                            <p><b>{{ taskDetail.key }}:</b>{{ returnTaskDetailValue(taskDetail.value) }} -- </p>
                            } @else {
                            <p><b>{{ taskDetail.key }}:</b> {{ returnTaskDetailValue(taskDetail.value) }}</p>
                            }
                        </ng-template>

                        <ng-template #listTemplate>
                            <div class="card">
                                <div class="card-body">
                                    <p class="red" *ngFor="let item of taskDetail.list">
                                        <b>{{ item.key }} :</b> {{ item.value }}
                                    </p>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                </ul>
                </p-accordion-content>
            </p-accordion-panel>
            <!-- } -->

            <p-accordion-panel value="1">
                <p-accordion-header>Source Files ({{ listFileSmartDocs.length }})</p-accordion-header>
                <p-accordion-content>
                <div style="max-height:300px" class="overflow-scroll">
                    <div class="col-12">
                        <label class="d-block">Smartdocs come from predecesor task:
                            <input type="checkbox" class="from-predecesor-check" [checked]="task?.fromPredecesor"
                                disabled>
                        </label>
                    </div>

                    <ul class="attach-list">
                        @for(smartdoc of listAllSmartDocs; track smartdoc) {
                        @if(smartdoc.category === 'file') {
                        <li class="flex items-center gap-2 border rounded mt-1 p-3">
                            <mat-icon svgIcon="mat:folder"></mat-icon>
                            @if(smartdoc.fileURL) {
                              <a href="{{ smartdoc.fileURL }}" target="_blank" rel="noopener"
                                  [ngClass]="{'cancelled': smartdoc.fileStatus == 'CANCELLED'}">{{
                                  smartdoc.fileName }}</a>
                            } @else {
                              <span [ngClass]="{'cancelled': smartdoc.fileStatus == 'CANCELLED'}"
                                  class="text-hint">{{
                                  smartdoc.fileName }}</span>
                            }
                        </li>
                        }
                        }
                    </ul>
                </div>
                </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="2" *ngIf="listDeliveryfileSmartDocs.length > 0">
                <p-accordion-header>Delivery Files ({{ listDeliveryfileSmartDocs.length }})</p-accordion-header>
                <p-accordion-content>
                <div style="max-height:300px" class="overflow-scroll">
                    <ul class="attach-list">
                        @for(smartdoc of listDeliveryfileSmartDocs; track smartdoc) {
                        @if(smartdoc.category === 'deliveryfile') {
                        <li class="flex items-center gap-2 border rounded mt-1 p-3">
                            <mat-icon svgIcon="mat:folder"></mat-icon>
                            @if(smartdoc.fileURL) {
                              <a href="{{ smartdoc.fileURL }}" target="_blank" rel="noopener"
                                  [ngClass]="{'cancelled': smartdoc.fileStatus == 'CANCELLED'}">{{
                                  smartdoc.fileName }}</a>
                            } @else {
                              <span [ngClass]="{'cancelled': smartdoc.fileStatus == 'CANCELLED'}"
                                  class="text-hint">{{
                                  smartdoc.fileName }}</span>
                            }
                        </li>
                        }
                        }
                    </ul>
                </div>
                </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="3" *ngIf="listAllSmartDocs.length > 0">
                <p-accordion-header>All Files</p-accordion-header>
                <p-accordion-content>
                <div style="max-height:300px" class="overflow-scroll">
                    <ul class="attach-list">
                        <li class="flex items-center gap-2 border rounded mt-1 p-3"
                            *ngFor="let smartdoc of listAllSmartDocs">
                            <mat-icon svgIcon="mat:folder"></mat-icon>
                            @if(smartdoc.fileURL) {
                              <a href="{{ smartdoc.fileURL }}" target="_blank" rel="noopener"
                                  [ngClass]="{'cancelled': smartdoc.fileStatus == 'CANCELLED'}">{{
                                  smartdoc.fileName }} ({{ smartdoc.category }})</a>
                            } @else {
                              <span [ngClass]="{'cancelled': smartdoc.fileStatus == 'CANCELLED'}"
                                  class="text-hint">{{
                                  smartdoc.fileName }} ({{ smartdoc.category }})</span>
                            }
                        </li>
                    </ul>
                </div>
                </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="4" *ngIf="listActions.length > 0">
                <p-accordion-header>Actions</p-accordion-header>
                <p-accordion-content>
                <div style="max-height:300px" class="overflow-scroll">
                    <p class="text-xs">
                        Click Force Task to return the project to this stage. Please note that this action will
                        erase all subsequent task modifications and files. If needed, you may still retrieve
                        these files from any email notifications that were previously sent. Be aware that these
                        files will be permanently deleted from the system after 30 days.
                    </p>
                    <ul class="attach-list mt-4">
                        <li *ngFor="let action of listActions" class="flex justify-center">
                            <button mat-stroked-button (click)="clickAction( action.actionURL )"
                                class="cursor-pointer">{{
                                action.label }}</button>
                        </li>
                    </ul>
                </div>
                </p-accordion-content>
            </p-accordion-panel>

        </p-accordion>
    </div>
    <!-- END ACCORDION -->
</div>
